import { render, staticRenderFns } from "./professionalInfoConsultationBuyTea.vue?vue&type=template&id=e5ec84b0&scoped=true"
import script from "./professionalInfoConsultationBuyTea.vue?vue&type=script&lang=js"
export * from "./professionalInfoConsultationBuyTea.vue?vue&type=script&lang=js"
import style0 from "./professionalInfoConsultationBuyTea.vue?vue&type=style&index=0&id=e5ec84b0&prod&lang=scss&scoped=true"
import style1 from "./professionalInfoConsultationBuyTea.vue?vue&type=style&index=1&id=e5ec84b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ec84b0",
  null
  
)

export default component.exports